/**
 * 日本語のルビ記法をHTMLのrubyタグに変換します。
 * 1. `|漢字《かんじ》` 形式 (明示的ルビ開始記号あり)
 * 2. `漢字《かんじ》` 形式 (漢字に直接続く、記号なし)
 */
export function parseRuby(text: string): string {
  if (!text.includes('《')) return text;

  let parsed = text.replace(/[|｜]([^《\n\r]+)《([^》\n\r]+)》/g, '<ruby>$1<rt>$2</rt></ruby>');
  parsed = parsed.replace(
    /([\u3005\u3007\u4e00-\u9faf]+)《([^》\n\r]+)》/g,
    '<ruby>$1<rt>$2</rt></ruby>',
  );

  return parsed;
}
